import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { SelectThemePage } from './select-theme';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../../../shared';
import { translateConfig } from '../../config/translate.config';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [
    SelectThemePage
  ],
  imports: [
    IonicModule,
    CommonModule,
    RouterModule.forChild([{ path: '', component: SelectThemePage }]),
    TranslateModule.forChild(translateConfig),
    SharedModule
  ]
})
export class SelectThemePageModule {}
